import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getJoinNameList, exportForAsync } from '@/request';
import { exportJoinNameList } from '@/request/api';
export default {
  name: 'JoinNameListModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    scienceId: {
      type: [String],
      default: ''
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    let total = 0;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();

    function exportExcel() {
      // window.open(
      //   `${exportJoinNameList.url}?scienceId=${props.scienceId}`,
      //   '_blank'
      // );
      exportForAsync({
        __repeat: true,
        __warn: true,
        scienceId: props.scienceId,
        modularflag: 'scienceAttendor',
        fileName: '学术项目参会名单',
        count: total,
        methodName: exportJoinNameList.url
      });
    }

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        var _table$value;

        (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
      }
    }, {
      flush: 'post'
    });
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        title: '企业名称',
        width: '200px',
        field: 'custName',
        showOverflow: true
      }, {
        title: '联系人姓名',
        width: '150px',
        field: 'linkMan',
        showOverflow: true
      }, {
        title: '手机号码',
        width: '200px',
        field: 'linkPhone',
        showOverflow: true
      }, {
        title: '推广业务员',
        width: '100px',
        field: 'supUserName',
        showOverflow: true
      }, {
        title: '所在区域',
        field: 'areaName',
        showOverflow: true
      }],
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getJoinNameList({
              page: page.currentPage,
              pageSize: page.pageSize,
              scienceId: props.scienceId
            }).then(data => {
              total = data.total;
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "参会名单",
        width: "1000px",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null)
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            icon: "Download",
            onClick: exportExcel
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          })]),
          _: 1
        }, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};